import { SVGProps } from './SVGProps';

const QuestionMark = ({ fill = 'none', width = '28', height = '23' }: SVGProps) => {
  return (
    <svg width={width} height={height} viewBox={`0 0 512 512`} fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_383_1051)">
        <path
          d={`M256 512C323.895 512 389.01 485.029 437.019 437.019C485.029 389.01 512 323.895 512 256C512 188.105 485.029 122.99 437.019 74.9807C389.01 26.9714 323.895 0 256 0C188.105 0 122.99 26.9714 74.9807 74.9807C26.9714 122.99 0 188.105 0 256C0 323.895 26.9714 389.01 74.9807 437.019C122.99 485.029 188.105 512 256 512ZM169.8 165.3C177.7 143 198.9 128 222.6 128H280.9C315.8 128 344 156.3 344 191.1C344 213.7 331.9 234.6 312.3 245.9L280 264.4C279.8 277.4 269.1 288 256 288C242.7 288 232 277.3 232 264V250.5C232 241.9 236.6 234 244.1 229.7L288.4 204.3C293.1 201.6 296 196.6 296 191.2C296 182.8 289.2 176.1 280.9 176.1H222.6C219.2 176.1 216.2 178.2 215.1 181.4L214.7 182.6C210.3 195.1 196.5 201.6 184.1 197.2C171.7 192.8 165.1 179 169.5 166.6L169.9 165.4L169.8 165.3ZM224 352C224 343.513 227.371 335.374 233.373 329.373C239.374 323.371 247.513 320 256 320C264.487 320 272.626 323.371 278.627 329.373C284.629 335.374 288 343.513 288 352C288 360.487 284.629 368.626 278.627 374.627C272.626 380.629 264.487 384 256 384C247.513 384 239.374 380.629 233.373 374.627C227.371 368.626 224 360.487 224 352Z`}
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_383_1051">
          <rect width={width} height={height} fill={fill} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default QuestionMark;
